import { API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUCCESS, API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS_SUCCESS, API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE_SUCCESS, API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER_SUCCESS, API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE_SUCCESS, } from '../actions/ProffitSearchSlideActions';
// eslint-disable-next-line default-param-last
export default (state = {}, { meta, payload, type }) => {
    switch (type) {
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUCCESS:
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER_SUCCESS:
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE_SUCCESS:
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS_SUCCESS: {
            // 取得した値を整形
            const { list } = payload;
            const slides = {};
            list.forEach((item) => {
                const { slide } = item;
                const { id } = slide;
                slides[id] = {
                    id,
                    result: true,
                    value: slide,
                };
            });
            return Object.assign(Object.assign({}, state), slides);
        }
        case API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE_SUCCESS: {
            const { list } = payload;
            const slides = {};
            const { ids = [] } = meta;
            // 取得した値を整形
            ids.forEach((metaId) => {
                const { slide } = list.find((v) => v.slideId === metaId) || {};
                slides[metaId] = {
                    id: metaId,
                    result: !!slide,
                    value: slide,
                };
            });
            return Object.assign(Object.assign({}, state), slides);
        }
        default: {
            return state;
        }
    }
};
